import React, {Component} from 'react'
import _ from 'lodash';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

/*** REACT TOOLBOX  ****/
import Input from 'react-toolbox/lib/input/Input';
import Button from 'react-toolbox/lib/button/Button';
import Autocomplete from 'react-toolbox/lib/autocomplete/Autocomplete';
import IconButton from 'react-toolbox/lib/button/IconButton';
import Chip from 'react-toolbox/lib/chip';


/*** REDUX  ****/
import {connect} from 'react-redux'
import {withRouter, Link, Redirect} from "react-router-dom";
import {bindActionCreators} from 'redux'
/*** REDUX ACTINS ***/
import * as stationsActions from '../../../../actions/stations'
import * as nodeDetailsActions from '../../../../actions/nodeDetails'
import * as DevicesActions from '../../../../actions/devices'

import {stationStatus} from '../../../../reducers/stations/stations'

import './SensorForm.css'
// import {PulseLoader} from "halogen";


const MySwal = withReactContent(Swal);

const initState = {
    currentNode: {
        node_id: '',
        from: new Date().toISOString()
    },
    status: 'disabled',
    historyNodes: []
};

const parseStation = (station) => {
  let newStation = initState;

  newStation.currentNode = station.currentNode.value;
  newStation.status = station.status.value;
  newStation.historyNodes = station.historyNodes.value;

  return newStation;
};

class StationForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            id: props.match.params.id !== 'new' ? props.match.params.id : '',
            station: props.match.params.id !== 'new' ? (props.stations.length > 0 ? parseStation(props.stations.find(device => device.id === props.match.params.id)) : initState) : initState,
            newStation: props.match.params.id === 'new',
            redirect: false,

            currentStation: {
                station_id: '',
                currentNode: {
                    node_id: '',
                    from: '',
                },
                status: ' '
            },
            auxNode_id: '',
            gasesInfo: [],
            currentNodeErr: false,
            content: false
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    // componentDidMount() {
        // this.props.devicesActions.getAllDevices();
    // }

    componentDidUpdate(prevProps) {
        let prevSensor = prevProps.stations.find(device => device.id === this.state.id);
        let newSensor = this.props.stations.find(device => device.id === this.state.id);

        if (prevSensor !== newSensor)
            this.setState({...this.state, station: parseStation(newSensor)});
    }

    handleChange(field, value) {
        let aux = this.state.station;

        if (field === 'station_id')
            this.setState({...this.state, id: value});
        else {
            if (field === 'node_id') {
                aux.currentNode[field] = value;
                aux.currentNode.from = new Date().toISOString();
            } else if (field === 'status')
                aux[field] = value;

            this.setState({...this.state, station: aux});
        }
    }

    handleSubmit() {
        if (this.state.newStation) {
            this.props.stationsActions.createStation(this.state.station, this.state.id, (response, err) => {
                if (!err) {
                    this.setState({...this.state, redirect: true});
                } else {
                    console.log(response);
                }
                //
                // if (err) {
                //     MySwal.fire({
                //         type: 'error',
                //         title: `Error: ${response.status}`,
                //         text: response.error
                //     });
                // } else {
                //     MySwal.fire({
                //         type: 'success',
                //         title: 'Success!',
                //         text: `Station ${response.id} created.`,
                //     });
                //     this.setState({
                //         ...this.state,
                //         currentStation: {
                //             station_id: '',
                //             currentNode: {
                //                 node_id: '',
                //                 from: new Date(),
                //             },
                //             status: ' '
                //         }
                //     })
                // }
            });
        } else {
            this.props.stationsActions.updateStation(this.state.id, this.state.station, (response, err) => {
                if (!err) {
                    this.setState({...this.state, redirect: true});
                } else {
                    console.log(response);
                }
                // if (err) {
                //     MySwal.fire({
                //         type: 'error',
                //         title: `Error: ${response.status}`,
                //         text: response.error
                //     });
                // } else {
                //     // TODO enseñar leo
                //
                //     MySwal.fire({
                //         toast: true,
                //         position: 'top-end',
                //         showConfirmButton: false,
                //         timer: 2000,
                //         title: 'Success!',
                //         text: 'Station updated.',
                //         type: 'success',
                //     });
                // }
            });
        }
    }

    handleKey(e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            this.handleSubmit();
        }
    }

    handleDeviceInfo(node_id) {
        let gasesInfo = [];

        this.props.nodeDetailsActions.getDeviceInfo(node_id, (gasInfo, err) => {
            if (!err)
                gasInfo.forEach((gas, index) => {
                    gasesInfo.push(<Chip key={index} className={'fadeInChip'}>{gas[`SN${index + 1}_TYPE`]}</Chip>);
                });
            this.setState({...this.state, gasesInfo});

            return 0;
        });
    }

    render() {
        if (this.state.redirect)
            return <Redirect push to={"/admin/stations"}/>;

        let title = this.state.newStation ? ' Station Registration ' : 'Station Details ';

        if (this.state.station) {
            return (
                <div className='col-xs-12'>

                    <div className="createSensor">
                        <h3 className="formHeader"> {title}</h3>
                        {/*{!this.props.isNew && <h4 className="formHeader"> {this.props.currentStation.id}</h4>}*/}

                        <Link to={'/admin/stations'}>
                            <IconButton primary
                                        className="buttonClose"
                                        icon="close"/>
                        </Link>

                        <form className={'stationDetailsContainer'} onKeyDown={this.handleKey.bind(this)}>
                            <Input required type="text" label="Station Id" name="station_id"
                                   value={this.state.id}
                                   disabled={!this.state.newStation}
                                   onChange={this.handleChange.bind(this, "station_id")}
                            />
                            <Autocomplete direction="down"
                                          label={this.state.newStation ? 'Station node' : 'Current node in station'}
                                          multiple={false}
                                          source={this.props.nodes.map(node => {
                                              return node.id
                                          })}
                                          showSuggestionsWhenValueIsSet={true}
                                          value={this.state.station.currentNode.node_id}
                                          disabled={this.state.station.status === 'active'}
                                          onChange={this.handleChange.bind(this, 'node_id')}
                            />

                            {this.state.currentNodeErr && <span style={{'color': 'red'}}>
                            In order to change the current node from the station, please change the status to idle or disabled </span>}

                            <div className={'nodeStationInfo'}>
                                <h4>Node Gases: </h4>
                                {this.state.gasesInfo}
                            </div>
                            <Autocomplete direction="down"
                                          label={'Status'}
                                          multiple={false}
                                          source={stationStatus}
                                          // disabled={!this.props.isAdmin}
                                          showSelectedWhenNotInSource={true}
                                          value={this.state.station.status}
                                          onChange={this.handleChange.bind(this, 'status')}
                            />
                            {(!this.state.newStation && this.state.station.historyNodes) &&

                            <div className={'historyNodesContainer'}>

                                <h4 style={{'color': '#173B62'}}>Nodes History</h4>

                                {this.state.station.historyNodes.map((node, key) => {
                                    return (
                                        <div key={key} className={'historyNodeItem'}>
                                            <Input type="text" label="Node Id" name={`node_id_${key}`}
                                                   key={key}
                                                   value={node.node_id}
                                                   disabled={true}
                                            />
                                            <Input type="text" label="From" name={`from_${key}`}
                                                   value={new Date(node.from).toUTCString()}
                                                   disabled={true}
                                            />
                                            <Input type="text" label="To" name={`to_${key}`}
                                                   value={new Date(node.to).toUTCString()}
                                                   disabled={true}
                                            />
                                        </div>)
                                })}

                            </div>}

                            <Button style={{marginTop: '20px'}} raised primary
                                    label={this.state.newStation ? 'SUBMIT' : 'UPDATE'}
                                    onClick={this.handleSubmit}
                            />
                        </form>
                    </div>
                </div>
            );
        } else {
            return (
                null
                // <PulseLoader className="LoadTable"
                //              color="#0A2A59"
                //              size={"20px"}
                //              margin={"4px"}/>
            );
        }

    }
}


const stationFormStateToProps = (state) => {
    return {
        stations: state.stations.stations,
        nodes: state.devices.list,
    }
};


const stationFormDispatchToProps = (dispatch) => {
    return {
        stationsActions: bindActionCreators(stationsActions, dispatch),
        devicesActions: bindActionCreators(DevicesActions, dispatch),
        nodeDetailsActions: bindActionCreators(nodeDetailsActions, dispatch)
    }
};

export default withRouter(connect(stationFormStateToProps, stationFormDispatchToProps)(StationForm));



// WEBPACK FOOTER //
// ./src/components/DashBoard/AdminStations/StationForm/StationForm.js